"use client";

import React, { useState } from "react";
import { MapPin } from "lucide-react";
import { cn } from "@/lib/utils";
const cities = [{
  id: "cer",
  name: "The Ceremony",
  top: "45%",
  left: "25%"
}, {
  id: "rec",
  name: "The Reception",
  top: "80%",
  left: "60%"
}, {
  id: "cock",
  name: "Cocktail Hour",
  top: "40%",
  left: "40%"
}, {
  id: "din",
  name: "Grand Dinner",
  top: "30%",
  left: "55%"
}, {
  id: "dan",
  name: "First Dance",
  top: "20%",
  left: "55%"
}, {
  id: "cake",
  name: "Cake Cutting",
  top: "45%",
  left: "60%"
}, {
  id: "send",
  name: "Sparkler Send-off",
  top: "35%",
  left: "35%"
}, {
  id: "hotel",
  name: "Guest Lodging",
  top: "65%",
  left: "40%"
}, {
  id: "brunch",
  name: "Farewell Brunch",
  top: "55%",
  left: "30%"
}, {
  id: "park",
  name: "Valet Parking",
  top: "60%",
  left: "65%"
}, {
  id: "photo",
  name: "Garden Portraits",
  top: "50%",
  left: "55%"
}, {
  id: "chap",
  name: "The Chapel",
  top: "25%",
  left: "30%"
}];
export default function ServingYourNeighborhood() {
  const [activeCity, setActiveCity] = useState<string | null>(null);
  return <section data-section-id="241006" id="where-when" className="bg-background text-foreground py-24 overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          
          {}
          <div className="relative w-full aspect-square max-w-md mx-auto lg:max-w-none lg:aspect-[4/3] rounded-lg overflow-hidden bg-secondary shadow-xl border border-border/50">
            {}
            <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680521/img/map.png)] bg-cover bg-center opacity-30 mix-blend-multiply transition-opacity duration-700"></div>
            
            {}
            <div className="absolute inset-0 bg-[linear-gradient(to_right,#00000005_1px,transparent_1px),linear-gradient(to_bottom,#00000005_1px,transparent_1px)] bg-[size:3rem_3rem]"></div>
            
            {}
            <div className="absolute inset-0 bg-gradient-to-t from-background/60 via-transparent to-transparent"></div>

            {}
            {cities.map((city, i) => <div key={city.id} data-index={i} className={cn("absolute -translate-x-1/2 -translate-y-1/2 transition-all duration-500 ease-out flex flex-col items-center cursor-pointer", activeCity === city.id ? "scale-125 z-20" : "scale-100 z-10 opacity-70 hover:opacity-100")} style={{
            top: city.top,
            left: city.left
          }} onMouseEnter={() => setActiveCity(city.id)} onMouseLeave={() => setActiveCity(null)}>
                <div className="relative flex items-center justify-center">
                  {}
                  <div className={cn("absolute inset-0 rounded-lg bg-primary blur-md transition-all duration-300", activeCity === city.id ? "opacity-40 scale-150" : "opacity-0 scale-100")}></div>
                  {}
                  <div className={cn("relative w-3 h-3 rounded-lg border-2 transition-colors duration-300", activeCity === city.id ? "bg-white border-primary shadow-md" : "bg-primary border-transparent")}></div>
                </div>

                {}
                <div className={cn("absolute top-full mt-3 px-3 py-1.5 bg-card/95 backdrop-blur-sm border border-border rounded-md shadow-lg transition-all duration-300 pointer-events-none", activeCity === city.id ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-2")}>
                  <span className="text-xs font-medium text-foreground whitespace-nowrap font-sans tracking-wider uppercase">
                    {city.name}
                  </span>
                </div>
              </div>)}
          </div>

          {}
          <div className="flex flex-col justify-center">
            <div className="mb-10">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground font-default tracking-tight mb-6">
                Where & <span className="text-primary italic font-serif">When</span>
              </h2>
              <p className="text-lg text-muted-foreground font-sans max-w-xl leading-relaxed">
                Join us at The Grand Estate for a day of celebration. From the intimate ceremony in the garden to the evening reception in the ballroom, we can't wait to share these moments with you.
              </p>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-4 gap-y-3">
              {cities.map((city, i) => <div key={city.id} data-index={i} className={cn("flex items-center gap-2.5 px-4 py-3 rounded-md cursor-pointer transition-all duration-300 border font-sans text-sm md:text-base group", activeCity === city.id ? "bg-accent text-accent-foreground border-primary/20 shadow-sm font-medium translate-x-1" : "bg-transparent border-transparent text-muted-foreground hover:bg-muted/50 hover:text-foreground")} onMouseEnter={() => setActiveCity(city.id)} onMouseLeave={() => setActiveCity(null)}>
                  <MapPin className={cn("w-4 h-4 transition-colors duration-300 shrink-0", activeCity === city.id ? "text-primary" : "text-muted-foreground/40 group-hover:text-muted-foreground")} />
                  <span className="truncate">{city.name}</span>
                </div>)}
            </div>
          </div>

        </div>
      </div>
    </section>;
}